/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type HappeningsContainer_lists$ref = any;
export type DeleteHeroOfferInput = {|
  clientMutationId?: ?string,
  id: string,
|};
export type deleteHappeningMutationVariables = {|
  input: DeleteHeroOfferInput
|};
export type deleteHappeningMutationResponse = {|
  +deleteHeroOffer: ?{|
    +destroyedHeroOfferId: string,
    +lists: {|
      +$fragmentRefs: HappeningsContainer_lists$ref
    |},
  |}
|};
export type deleteHappeningMutation = {|
  variables: deleteHappeningMutationVariables,
  response: deleteHappeningMutationResponse,
|};
*/


/*
mutation deleteHappeningMutation(
  $input: DeleteHeroOfferInput!
) {
  deleteHeroOffer(input: $input) {
    destroyedHeroOfferId
    lists {
      ...HappeningsContainer_lists
      id
    }
  }
}

fragment HappeningCell_happening on HeroOffer {
  id
  title
  url
  imageUrl
  startDate
  endDate
}

fragment HappeningsContainer_lists on Lists {
  heroOffers {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        ...HappeningCell_happening
        __typename
      }
      cursor
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteHeroOfferInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "destroyedHeroOfferId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteHappeningMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteHeroOfferPayload",
        "kind": "LinkedField",
        "name": "deleteHeroOffer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Lists",
            "kind": "LinkedField",
            "name": "lists",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "HappeningsContainer_lists"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteHappeningMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteHeroOfferPayload",
        "kind": "LinkedField",
        "name": "deleteHeroOffer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Lists",
            "kind": "LinkedField",
            "name": "lists",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "HeroOfferConnection",
                "kind": "LinkedField",
                "name": "heroOffers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HeroOfferEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HeroOffer",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "imageUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "filters": [
                  "active",
                  "startingAfter",
                  "endingBefore"
                ],
                "handle": "connection",
                "key": "HappeningsContainer_heroOffers",
                "kind": "LinkedHandle",
                "name": "heroOffers"
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteHappeningMutation",
    "operationKind": "mutation",
    "text": "mutation deleteHappeningMutation(\n  $input: DeleteHeroOfferInput!\n) {\n  deleteHeroOffer(input: $input) {\n    destroyedHeroOfferId\n    lists {\n      ...HappeningsContainer_lists\n      id\n    }\n  }\n}\n\nfragment HappeningCell_happening on HeroOffer {\n  id\n  title\n  url\n  imageUrl\n  startDate\n  endDate\n}\n\nfragment HappeningsContainer_lists on Lists {\n  heroOffers {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    edges {\n      node {\n        id\n        ...HappeningCell_happening\n        __typename\n      }\n      cursor\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9e48c8e60c44ec0c8f40410946e7b00a';

module.exports = node;
